"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PillType = exports.PillSize = void 0;
var PillType = exports.PillType = /*#__PURE__*/function (PillType) {
  PillType["Draft"] = "draft";
  PillType["Sent"] = "sent";
  PillType["Success"] = "success";
  PillType["Template"] = "template";
  PillType["InProgress"] = "in_progress";
  PillType["Warning"] = "warning";
  PillType["Expired"] = "expired";
  PillType["Default"] = "default";
  return PillType;
}({});
var PillSize = exports.PillSize = /*#__PURE__*/function (PillSize) {
  PillSize["Small"] = "sm";
  PillSize["Medium"] = "md";
  return PillSize;
}({});
//# sourceMappingURL=HBPill.types.js.map